import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'owlCarousel',
  setup(__props) {

const slidesOnly = defineAsyncComponent(() => import("@/components/theme/advance/owlcarousel/slidesOnly.vue"))
const withControls = defineAsyncComponent(() => import("@/components/theme/advance/owlcarousel/withControls.vue"))
const autoPlay = defineAsyncComponent(() => import("@/components/theme/advance/owlcarousel/autoPlay.vue"))
const mouseWheel = defineAsyncComponent(() => import("@/components/theme/advance/owlcarousel/mouseWheel.vue"))
const withIndicators = defineAsyncComponent(() => import("@/components/theme/advance/owlcarousel/withIndicators.vue"))
const withCaptions = defineAsyncComponent(() => import("@/components/theme/advance/owlcarousel/withCaptions.vue"))
const crossFade = defineAsyncComponent(() => import("@/components/theme/advance/owlcarousel/crossFade.vue"))
const individualCarousel = defineAsyncComponent(() => import("@/components/theme/advance/owlcarousel/individualCarousel.vue"))
const disableTouch = defineAsyncComponent(() => import("@/components/theme/advance/owlcarousel/disableTouch.vue"))
const darkVariant = defineAsyncComponent(() => import("@/components/theme/advance/owlcarousel/darkVariant.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Bonus Ui",
      title: "Owl Carousel"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(slidesOnly)),
        _createVNode(_unref(withControls)),
        _createVNode(_unref(autoPlay)),
        _createVNode(_unref(mouseWheel)),
        _createVNode(_unref(withIndicators)),
        _createVNode(_unref(withCaptions)),
        _createVNode(_unref(crossFade)),
        _createVNode(_unref(individualCarousel)),
        _createVNode(_unref(disableTouch)),
        _createVNode(_unref(darkVariant))
      ])
    ])
  ], 64))
}
}

})